import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ChangeEvent } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export function SearchInput({
  placeholder,
  onSubmit,
  defaultValue,
  value,
  onChange,
  width,
}: {
  placeholder?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  defaultValue?: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  width?: string;
}) {
  const { t } = useTranslation();
  const searchPlaceholder = placeholder || t('wbs.search-2');
  const formRef = useRef<HTMLFormElement>(null);

  const handleIconClick = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };

  return (
    <SearchForm ref={formRef} onSubmit={onSubmit}>
      <StyledInput
        name="search_term"
        placeholder={searchPlaceholder}
        defaultValue={value === undefined ? defaultValue : undefined}
        value={value}
        onChange={onChange}
        $width={width}
      />
      <SearchIcon icon={faMagnifyingGlass} onClick={handleIconClick} />
    </SearchForm>
  );
}

const SearchForm = styled.form`
  display: flex;
  margin-bottom: 0;
  position: relative;
`;

const StyledInput = styled.input<{ $width?: string }>`
  border: 0;
  border-radius: 5px;
  box-shadow: var(--shadow-inset-lg);
  color: var(--black);
  font-family: var(--raleway);
  font-size: 13px;
  font-weight: 400;
  height: 22px;
  min-width: ${(props) => props.$width ?? '180px'};
  outline: none;
  padding-left: 10px;
  width: ${(props) => props.$width ?? '100%'};

  &::placeholder {
    color: var(--grey-600);
  }
`;

const SearchIcon = styled(FontAwesomeIcon)`
  color: var(--grey-600);
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;
